import type { SeedStatsDto } from '@/core/data/seed/seed.interface';
import { SeedEndpoint } from '@/core/network/api/constants/api.url.constant';
import type { HttpClient } from '@/core/network/http/httpClient';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import type { AxiosResponse } from 'axios';

export class SeedApi {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getStats(): Promise<AxiosResponse<GamResponse<SeedStatsDto>>> {
    return this.httpClient.get<SeedStatsDto>(SeedEndpoint.GET_STATS);
  }
}
